import { formatDateOnlyShort } from '@/app/utils/formatDate';
import type { SmriqLastCompletedServiceSelection } from '../types/smriq.types';
import { isAutoMatch } from './isAutoMatch';

export const lastCompletedServiceRecap = (
    selection: SmriqLastCompletedServiceSelection | null,
): string => {
    if (!selection) return 'Not known';
    return [
        isAutoMatch(selection) ? 'Auto match' : selection.label,
        formatDateOnlyShort(selection.completed_date),
        `${selection.completed_mileage.toLocaleString()} miles`,
    ].join(' · ');
};
